import { render } from "./barcordReader.vue?vue&type=template&id=2823a62e&scoped=true"
import script from "./barcordReader.vue?vue&type=script&lang=js"
export * from "./barcordReader.vue?vue&type=script&lang=js"

import "./barcordReader.vue?vue&type=style&index=0&id=2823a62e&lang=css"
import "./barcordReader.vue?vue&type=style&index=1&id=2823a62e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2823a62e"]])

export default __exports__